__turbopack_context__.v({
  "accessory": "AvatarWithAccessory-module__-Jbmhq__accessory",
  "avatarContainer": "AvatarWithAccessory-module__-Jbmhq__avatarContainer",
  "avatarInactive": "AvatarWithAccessory-module__-Jbmhq__avatarInactive",
  "relaxingAvatar": "AvatarWithAccessory-module__-Jbmhq__relaxingAvatar",
  "root": "AvatarWithAccessory-module__-Jbmhq__root",
});
